module.exports = __webpack_public_path__ + "static/img/logo_TY.3ba196a1.png";